import { ReactNode } from 'react';

export function FullScreenLayout(page: ReactNode) {
  return <div style={{ width: '100%', height: '100%' }}>{page}</div>;
}
